angular
  .module("app")
  .controller("PracticeDetailCtrl", function (
    $scope,
    $transactionFactory,
    $configService,
    $location
  ) {
    var init = function () {
      $scope.instantModel = $transactionFactory.get();
      $scope.labelStepBar = ['In lavorazione', 'Richiesta valutata', 'Contratto firmato', 'Consegnato'];
    };

    init();

    $scope.generateDownloadLinkPersonalDocs = function (nameFile, cf) {
      return (
        $configService.getUrl() +
        "/uni/download/service-infos/" +
        encodeURIComponent(cf) +
        "/F9F57B1B9DE5245527EE44BB85D3D4992236F1F7/" +
        nameFile +
        "/PERSONAL_DOCUMENTS/?token=" +
        $configService.getAppConfig().token
      );
    };

    $scope.generateDownloadLinkAdditionalDocs = function (nameFile, idWfInstance) {
      return (
        $configService.getUrl() +
        "/uni/download/service-infos/" +
        encodeURIComponent(idWfInstance) +
        "/052/" +
        nameFile +
        "/IL/?token=" +
        $configService.getAppConfig().token
      );
    };

    $scope.gotoHome = function () {
      $location.path("/home");

    }

  });